// extracted by mini-css-extract-plugin
module.exports = {"pseudolink":"_9400a595a7--pseudolink--sp5id"};